import {getField, updateField} from 'vuex-map-fields';
import {AppWebSocket} from '@/commonFunction/appWebSocket'

export default class {
    constructor(wsUrl) {
        this.state = {
            wsUrl: wsUrl,
            webConnect: null,
            message_error: null,
            itemList: [],
            aggregateItemList: {},
            commonRecords: {},
            briefView: true,
            briefItemList: [],
            searchTerm: null,
            searchTermFile: null,
            filters: {},
            selectedItemList: [],
            selected_number: null,
            newItem: {'id': null},
            editedItem: {'id': null},
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['title'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
            totalRecords: 0,
            loading: false,
            action_loading: false,
            action_unrefreshed: false,
            briefLoading: false,
            deleteLoading: false,
            updateLoading: false,
            restoring: false,
            onlyFailedView: false,
            isAlive: true,

            snack_color: 'info',
            snack_text: '',
            snack_flag: false,

            confirm_dialog: false,
            confirm_title: null,
            confirm_body: null,
            confirm_result: true,
            confirm_type: 'error',
            confirm_parameters: {},

            lang: 'de',
            local: {},

            confirm_request: {
                dialog: false,
                message: null,
                request: {},
                type: null,
                timeout: -1,
                result: false,
            }
            ,
        }
        this.actions = {
            async openWebSocket(ctx) {
                if (ctx.state.webConnect == null) {
                    console.log('openWebSocket to ' + ctx.state.wsUrl)
                    ctx.state.webConnect = new AppWebSocket(ctx.state.wsUrl, ctx, 'fetchMessage', 5000)
                    ctx.state.webConnect.connectSocket()
                }
                while (ctx.state.webConnect.connection.readyState !== WebSocket.OPEN) {
                    // console.log('Wait while not connected to', ctx.state.webConnect.connection.url)
                    await delay(100)
                }
            },
            async fetchMessage(ctx, data) {
                console.log('fetchMessage ', ctx.state.wsUrl, data)
                ctx.state.action_unrefreshed = false

                ctx.commit('updateMessageError', data.message_error)

                if (data.command === 'order') {
                    if (data.order_list.includes(null)) {
                        // console.log('fetchMessage command: order', data)
                        ctx.dispatch('fetchItemList')
                        return
                    }
                }

                if (data.command === 'refresh') {
                    ctx.dispatch('fetchItemList')
                    return
                }

                if (data.command === 'delete' || data.command === 'restore_deleted') {
                    // console.log('fetchMessage, command: delete or restore_deleted', data)
                    const deletedItemList = ctx.state.itemList.filter(item => data.id_list.includes(item.id))
                    if (deletedItemList.length > 0) {
                        ctx.dispatch('fetchItemList')
                    }
                }

                ctx.commit('updateMessage', data)
            },

            async fetchRequest(ctx) {
                console.log('fetchRequest', ctx.state.wsUrl, ctx.state.confirm_request.request)
                ctx.state.webConnect.connection.send(JSON.stringify(ctx.state.confirm_request.request))
            },
            async fetchBriefItemList(ctx, dto_model=null) {
                console.log('fetchBriefItemList', ctx.state.wsUrl, dto_model)
                ctx.commit('updateBriefLoading', true)
                await ctx.dispatch('openWebSocket')
                let request = {
                    command: 'brief_list',
                }
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },
            async fetchItem(ctx, {itemId, dto_model, password}) {
                console.log('fetchItem', ctx.state.wsUrl, itemId, dto_model)
                const id = parseInt(itemId, 10)
                ctx.commit('updateLoading', true)
                ctx.commit('updateEditedItem', {'id': id})
                await ctx.dispatch('openWebSocket')
                let request = {
                    command: 'detail',
                    id: id,
                    password: password,
                    dto_model: dto_model
                }
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },
            async fetchSaveItemField(ctx, {itemId, fields_dict, dto_model}) {
                console.log('fetchSaveItemField', ctx.state.wsUrl, itemId, fields_dict, dto_model)
                ctx.commit('updateLoading', true)
                await ctx.dispatch('openWebSocket')
                let request = {}
                if (itemId !== null) {
                    fields_dict['id'] = itemId
                    request.command = 'save'
                    request.id = itemId
                    request.fields = fields_dict
                } else {
                    request.command = 'new'
                    request.fields = fields_dict
                }
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },
            async fetchOrderItemList(ctx, itemIdList, dto_model=null) {
                console.log('fetchOrderItemList', ctx.state.wsUrl, itemIdList, dto_model)
                ctx.commit('updateLoading', true)
                await ctx.dispatch('openWebSocket')
                let request = {
                    command: 'order',
                    order_list: itemIdList
                }
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },
            async fetchItemList(ctx, dto_model=null) {
                // console.log('fetchItemList', ctx.state.wsUrl, ctx.state.filters, dto_model)
                ctx.commit('updateLoading', true)
                await ctx.dispatch('openWebSocket')
                const page = ctx.state.options.page
                const page_size = ctx.state.options.itemsPerPage
                let orders = ctx.state.options.sortBy[0]
                if (ctx.state.options.sortDesc[0] == true) {
                    orders = '-' + orders
                }
                let filters = {}
                filters['alive'] = ctx.state.isAlive
                filters['only_failed_status'] = ctx.state.onlyFailedView
                if (ctx.state.searchTerm != null) {
                    filters['search_term'] = ctx.state.searchTerm
                }
                if (ctx.state.searchTermFile != null) {
                    filters['file_search_term'] = ctx.state.searchTermFile
                }
                filters = {
                    ...filters,
                    ...ctx.state.filters,
                }
                // console.log('Filters', filters, ctx.state.filters)
                let request = {
                    command: 'list',
                    orders: orders,
                    filters: filters,
                    page: page,
                    page_size: page_size,
                }
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                console.log('fetchItemList', ctx.state.wsUrl, ctx.state.filters, request, dto_model)
            },
            async fetchDeleteSelectedItem(ctx, dto_model=null) {
                console.log('fetchDeleteSelectedItem', ctx.state.wsUrl, ctx.state.selectedItemList, dto_model)
                let selectedIds = []
                for (const item of ctx.state.selectedItemList)
                    selectedIds.push(item.id)
                ctx.commit('updateDeleteLoading', true)
                let request = {
                    command: 'delete',
                    id_list: selectedIds,
                }
                await ctx.dispatch('openWebSocket')
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                ctx.commit('updateSelectedItemList', [])
                ctx.commit('updateDeleteLoading', false)
            },
            async fetchActionSelectedItem(ctx, action_name, dto_model=null) {
                console.log('fetchActionSelectedItem', ctx.state.wsUrl, action_name, ctx.state.selectedItemList, dto_model)
                let selectedIds = []
                for (const item of ctx.state.selectedItemList)
                    selectedIds.push(item.id)
                ctx.commit('updateActionLoading', true)
                let request = {
                    command: 'action',
                    action_name: action_name,
                    id_list: selectedIds,
                }
                await ctx.dispatch('openWebSocket')
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                ctx.commit('updateSelectedItemList', [])
                ctx.commit('updateActionLoading', false)
            },
            async fetchConfirmResponse(ctx, confirm, dto_model=null) {
                console.log('fetchConfirmResponse', confirm, dto_model)
                ctx.commit('updateActionLoading', true)
                let request = {
                    command: 'confirm_response',
                    confirm: confirm,
                }
                await ctx.dispatch('openWebSocket')
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },
            async fetchActionItem(ctx, {action_name, parameters, id_list, dto_model}) {
                console.log('fetchActionItem', action_name, parameters, id_list, dto_model)
                ctx.commit('updateActionLoading', true)
                ctx.commit('updateActionLoading', true)
                let request = {
                    command: 'action',
                    action_name: action_name,
                    id_list: id_list,
                    parameters: parameters,
                }
                request['dto_model'] = dto_model
                await ctx.dispatch('openWebSocket')
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                ctx.commit('updateActionLoading', false)
                // console.log('fetchActionItem', request)
            },
            async fetchSyncNotionSelectedItems(ctx, dto_model=null) {
                console.log('fetchSyncNotionSelectedItems', ctx.state.wsUrl, ctx.state.selectedItemList, dto_model)
                let selectedIds = []
                for (const item of ctx.state.selectedItemList)
                    selectedIds.push(item.id)
                ctx.commit('updateSyncNotionLoading', true)
                let request = {
                    command: 'update_from_notion',
                    id_list: selectedIds,
                }
                request['dto_model'] = dto_model
                await ctx.dispatch('openWebSocket')
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                ctx.commit('updateSelectedItemList', [])
                ctx.commit('updateSyncNotionLoading', false)
            },
            async fetchRestoreSelectedItems(ctx, dto_model=null) {
                console.log('fetchRestoreSelectedItems', ctx.state.wsUrl, ctx.state.selectedItemList, dto_model)
                ctx.commit('updateRestoring', true)
                let selectedIds = []
                for (const item of ctx.state.selectedItemList)
                    selectedIds.push(item.id)
                let request = {
                    command: 'restore_deleted',
                    id_list: selectedIds,
                }
                request['dto_model'] = dto_model
                await ctx.dispatch('openWebSocket')
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                ctx.commit('updateSelectedItemList', [])
                ctx.commit('updateRestoring', false)
            },
        }

        this.mutations = {
            updateField,
            updateMessage(state, data) {
                console.log('updateMessage', state.wsUrl, data, state.editedItem)
                if (data.command === 'list') {
                    // console.log('updateMessage, command: list')
                    state.totalRecords = data.total_records
                    state.commonRecords = data.common_records
                    state.itemList = JSON.parse(JSON.stringify(data.items))
                    if (data.aggregate_items)
                        state.aggregateItemList = JSON.parse(JSON.stringify(data.aggregate_items))
                    else
                        state.aggregateItemList = {}
                    state.loading = false
                    state.selectedItemList = []
                }
                if (data.command === 'brief_list') {
                    // console.log('updateMessage, command: brief_list')
                    state.briefItemList = data.items
                    state.briefLoading = false
                }
                if (data.command === 'confirm_dialog') {
                    // console.log('updateMessage, command: confirm', data, state.confirm_dialog, state.wsUrl)
                    state.confirm_dialog = true
                    state.confirm_result = true
                    state.confirm_title = data.confirm_title
                    state.confirm_body = data.confirm_body
                    state.confirm_type = data.confirm_type
                    state.confirm_parameters = data.confirm_parameters
                }
                if (data.command === 'confirm_request') {
                    state.confirm_request.dialog = true
                    state.confirm_request.message = data.message
                    state.confirm_request.request = data.request
                    state.confirm_request.type = data.type
                    state.confirm_request.timeout = data.timeout
                    state.confirm_request.color = data.color
                    state.loading = false
                    state.action_loading = false
                    state.briefLoading = false
                    state.deleteLoading = false
                    state.updateLoading = false
                }
                if (data.command === 'detail') {
                    console.log('updateMessage, command: detail', state.editedItem, data)
                    let rowList = []
                    let existFlag = false
                    for (let item of state.itemList) {
                        if (item.id === data.id) {
                            rowList.push(data.item)
                            existFlag = true
                        }
                        else
                            rowList.push(item)
                    }
                    if (state.editedItem !== null && state.editedItem.id === data.id)
                        state.editedItem = data.item
                    state.itemList = JSON.parse(JSON.stringify(rowList))
                    state.loading = false
                    // if (existFlag === false) {
                    //         if (state.options.page === 1)
                    //             state.itemList.unshift(data.item)
                    //         state.totalRecords += 1
                    //     }
                }
                if (data.command === 'new') {
                    console.log('updateMessage, command: new', data)
                    state.editedItem = data.item
                    state.totalRecords += 1
                    state.options.page = 1
                    const item_list_ids = []
                    for (const item of state.itemList)
                        item_list_ids.push(item.id)
                    if (!item_list_ids.includes(data.item.id)) {
                        if (data.item.hasOwnProperty('order_number'))
                            state.itemList.push(data.item)
                        else
                            state.itemList.unshift(data.item)
                    }
                    state.loading = false
                }
                if (data.command === 'order') {
                    // console.log('updateMessage, command: order', data)
                    data.order_list.forEach(function (order_number, index) {
                        let item = state.itemList.find(row => order_number !== null && row.id == order_number)
                        if (item !== undefined)
                            item.order_number = index
                        console.log('item', item)
                    })
                    state.loading = false
                }
                if (data.command === 'partial_detail') {
                    console.log('updateMessage, command: partial_detail', state.itemList, data)
                    if (data.message_error === null) {
                        console.log('updateMessage check message_error, command: partial_detail')
                        let rowList = []
                        let existFlag = false
                        for (let item of state.itemList) {
                            if (item.id === data.id) {
                                rowList.push({...item, ...data.item})
                                existFlag = true
                            } else
                                rowList.push(item)
                        }
                        if (state.editedItem !== null && state.editedItem.id === data.id)
                            state.editedItem = {...state.editedItem, ...data.item}
                        state.itemList = JSON.parse(JSON.stringify(rowList))
                        if (existFlag === false) {
                            if (state.options.page === 1)
                                state.itemList.unshift(data.item)
                            state.totalRecords += 1
                        }
                    }
                    state.loading = false
                    console.log('End updateMessage, command: partial_detail', state.itemList)
                }
                if (data.command === 'delete') {
                    // console.log('updateMessage, command: delete')
                    state.deleteLoading = false
                }
                if (data.command === 'restore_deleted') {
                    // console.log('updateMessage, command: restore_deleted')
                    state.restoring = false
                }
                if (data.command === 'warning') {
                    console.log('updateMessage, command: warning')
                    state.snack_color = 'warning'
                    state.snack_text = data.text
                    state.snack_flag = true
                }
                if (data.command === 'error') {
                    console.log('updateMessage, command: error')
                    state.snack_color = 'error'
                    state.snack_text = data.text
                    state.snack_flag = true
                }
                if (data.command === 'info') {
                    console.log('updateMessage, command: info')
                    state.snack_color = 'info'
                    state.snack_text = data.text
                    state.snack_flag = true
                }
            }
            ,
            updateItemList(state, rowList) {
                // console.log('updateItemList', rowList)
                state.itemList = JSON.parse(JSON.stringify(rowList))
            }
            ,
            updateItem(state, newItem) {
                // console.log('before updateItem', state.rowList, state.savedItemList)
                let rowList = []
                for (let item of state.itemList) {
                    if (item.id === newItem.id)
                        rowList.push(newItem)
                    else
                        rowList.push(item)
                }
                state.itemList = JSON.parse(JSON.stringify(rowList))
            }
            ,

            updateTotalRecords(state, totalRecords) {
                state.totalRecords = totalRecords
            }
            ,
            updateSelectedItemList(state, selectedItemList) {
                state.selectedItemList = selectedItemList
            }
            ,
            updateLoading(state, loading) {
                state.loading = loading
            }
            ,
            updateBriefLoading(state, briefLoading) {
                state.briefLoading = briefLoading
            }
            ,
            updateRestoring(state, restoring) {
                state.restoring = restoring
            }
            ,
            updateDeleteLoading(state, deleteLoading) {
                state.deleteLoading = deleteLoading
            }
            ,
            updateSyncNotionLoading(state, updateLoading) {
                state.updateLoading = updateLoading
            }
            ,
            updateEditedItem(state, item) {
                // console.log('updateEditedItem', item)
                state.editedItem = item
            },
            updateActionLoading(state, action_loading) {
                // console.log('updateActionLoading', action_loading)
                state.action_loading = action_loading
                state.action_unrefreshed = action_loading
            },
            updateActionUnrefreshed(state, action_unrefreshed) {
                // console.log('updateActionLoading', action_loading)
                state.action_unrefreshed = action_unrefreshed
            }
            ,
            updateFilters(state, filters) {
                // console.log('updateFilters', filters)
                state.filters = filters
            }
            ,
            updateMessageError(state, message_error) {
                state.message_error = message_error
            },
        }

        this.getters = {
            getField,
        }
    }
}


function

delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}